import { Id } from '@typings';

import { showroomApi } from '../services/api';

export const getSlug = async () => showroomApi.GET('/cms/homepage')({});

export const setSlug = async (slug: Nullable<string>) => showroomApi.PUT('/cms/homepage')({ data: { slug } });

export const getSlugForBuyer = async (buyer?: Id) => showroomApi.POST('/homepage')({ data: { buyer } });
